export const getYearRangeOptions = (yearsBack = 5, yearsForward = 10): number[] => {
    const currentYear = new Date().getFullYear();
    const years: number[] = [];
    for (let year = currentYear - yearsBack; year <= currentYear + yearsForward; year++) {
        years.push(year);
    }
    return years;
};
